//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

import { ColumnModel } from '../../api/api.models'

import { LocalDictionaryFactory } from '../../api/api.module'

import { HistorySource } from '../../common/history/history.directive.controller'

import { CreateEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { Details, DetailsScope, DetailsAccordion, DetailsAccordionSection } from '../../common/common.details'
import { DetailsParametersOptions } from '../../common/details-parameters/details-parameters.directive'
import { DetailsPopupOptions, DetailsOptions } from '../../common/details-popup/details-popup.directive'
import { GridBridge } from '../../common/common.interfaces'
import { GridController, GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { LoggerService } from '../../common/common.module'

import { GridService } from '../../../services/grid'

import {
    CommonHelper, ConfigHelper, ConvertHelper, DataTypeGroupComponent, EventsNames,
    OperatorLayoutSettings, LocalizationHelper, ToastHelper, TemplateHelper
} from '../../../helpers/'
import { FileComponent } from '../../../helpers/file-component'

import { Activity, Enums } from '../../../models/common/'

import { OpIssue, OpDataTypeInGroup, OpFile, OpTask, OpLocation } from '../../../models/core/'

import { IssueHelper } from '../issues.helper'
import { AttachmentService } from '../../../services/attachments'
import { UserSessionService } from '../../../services/user-session'
import { IMRImageOptions, IIMRImage, IMRImageInitializedArgs } from '../../common/image/';

interface IssueDetailsScope extends DetailsScope {
    ISSUE_COMMON_TAB_NAME: string
    ISSUE_HISTORY_TAB_NAME: string
    ISSUE_ATTACHMENTS_ACCORDION_NAME: string
    ISSUE_PARAMS_ACCORDION_NAME: string
    ISSUE_TASKS_ACCORDION_NAME: string
    ISSUE_EQUIPMENT_ACCORDION_NAME: string

    attachment: any[]
    attachments: OpFile[]
    attachmentsBridge: GridBridge
    attachmentsGridOptions: GridOptions

    deleteConfirmationOptions: {
        title: string

        onConfirmed: () => void
    }
    detailsParametersOptions: DetailsParametersOptions
    downloadButton: DevExpress.ui.dxButton
    downloadButtonOptions: DevExpress.ui.dxButtonOptions
    editId: number
    equipments: OpLocation[]
    equipmentGridOptions: GridOptions
    id: number
    itemObjects: any[]
    issuesDetailsPopupId: number
    issueTasksGridOptions: GridOptions
    issuesHistoryOptions: HistorySource
    issueGroupsGridEditOptions: GridBridge
    issueAttachmentsEditOptions: GridBridge
    issueTasksEditOptions: GridBridge
    isAttachLoading: boolean
    isAttachmentPreviewFullscreen: boolean
    popupTitle: string
    showAttPreview: boolean

    downloadAttachment()
    resizePreview()
}

export class IssueDirectiveController extends Details<IssueDetailsScope> {

    // Consts

    private get ISSUE_COMMON_TAB_NAME() { return 'ISSUE_COMMON_TAB_NAME' }
    private get ISSUE_HISTORY_TAB_NAME() { return 'ISSUE_HISTORY_TAB_NAME' }
    private get ISSUE_ATTACHMENTS_ACCORDION_NAME() { return 'ISSUE_ATTACHMENTS_ACCORDION_NAME' }
    private get ISSUE_PARAMS_ACCORDION_NAME() { return 'ISSUE_PARAMS_ACCORDION_NAME' }
    private get ISSUE_TASKS_ACCORDION_NAME() { return 'ISSUE_TASKS_ACCORDION_NAME' }
    private get ISSUE_EQUIPMENT_ACCORDION_NAME() { return 'ISSUE_EQUIPMENT_ACCORDION_NAME' }
    private static get LOG_STRING(): string { return '[SIMAX.Issues.Details.Controller] - %s' }

    // Consts End

    // Members

    public imageOptions: IMRImageOptions

    private attachmentsGrid: GridController<OpFile>
    private attachmentPreviewImageElement: any
    private parentElement: any
    private referenceObject: OpIssue
    private referenceObjectId: number
    private tasksGrid: GridController<OpTask>
    private image: IIMRImage

    // Members End

    constructor(
        $scope: IssueDetailsScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        private gridService: GridService,
        private attachmentService: AttachmentService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $q, logger, localDictionary, OperatorLayoutSettings.ContactPopupTabActive, userSession, referenceType)

        this.setConfirmationsOptions()
        this.setEvents()
        this.setOptions()
        this.setTemplateConsts()
        this.setAttachmentsOptions()
        this.setImageOptions()

        if (this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_LIST)) {
            this.configureTabs(this.getTabs())
        }
    }

    // Events

    private onOpen(options: DetailsOptions): void {
        this.$scope.detailsOpenParams = options

        this.referenceObjectId = options.referenceObjectId

        this.onClear()
        this.onRefresh()
        this.setAttachmentOptions()
        this.setHistoryOptions()
        this.showPopup()
    }

    private onRefresh(toRefresh: OpIssue = null): void {
        const deferred: JQueryDeferred<OpIssue> = $.Deferred<OpIssue>()

        if (!toRefresh) {
            this.userSession
                .getDataProvider().Issue
                .getIssue(this.referenceObjectId)
                .then((result: OpIssue) => {
                    this.$scope.popupTitle = result.toString()

                    deferred.resolve(result)
                })
                .fail((error: any) => {
                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                    ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))

                    console.warn(IssueDirectiveController.LOG_STRING, `Unable to Load data. Error: ${errorMsg}.`)
                })
                .always(() => {
                    this.$scope.showTabs = true
                })
        } else {
            deferred.resolve(toRefresh)
        }

        deferred
            .promise()
            .then((result: OpIssue) => {
                if (result && (!this.referenceObject || this.referenceObject.idIssue == result.idIssue)) {
                    this.referenceObject = result

                    this.getAttachmentData();
                    this.getEquipmentData(result);
                    this.setTaskColumns(result);
                    this.setBasicParameters(result);
                }
            })
    }

    private onEditIssueAttachments(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_ATTACHMENTS_EDIT_POPUP + this.$scope.detailsPopupId + "attachments")
    }

    private onEditIssueTasks(): void {
        this.$scope.$broadcast(EventsNames.OPEN_GRID_EDIT_POPUP + this.$scope.detailsPopupId + 'tasks')
    }

    private onEditIssueParams(): void {
        const createEditInitParams: CreateEditInitParams = IssueHelper.getCreateEditOptions(this.referenceObject.idIssue, this.referenceObject)
        this.$scope.$root.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
    }

    private onClear(): void {
        this.$scope.popupTitle = ''
        this.$scope.showTabs = false

        this.referenceObject = null
        this.$scope.detailsParametersOptions = null
        this.$scope.equipmentGridOptions = null
        this.$scope.attachmentsGridOptions = null

        this.$scope.issueGroupsGridEditOptions = null

        this.$scope.issueTasksEditOptions = null
        this.$scope.issueAttachmentsEditOptions = null
        this.$scope.attachmentsBridge = null
    }

    private onClose(): void {
        this.hidePopup()
    }

    private onDeleteIssue(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.detailsPopupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onConfirmDelete(): void {
        IssueHelper
            .deleteIssue(this.userSession.getDataProvider(), this.referenceObject, this.moduleName)
            .then((result: OpIssue) => {
                this.onClose()
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
            .fail((error: any) => {
                this.logger.log(error)
            })
    }

    private onTaskDetailsPopupOpen(e): void {
        this.$scope.$broadcast(EventsNames.OPEN_TASKS_DETAILS_POPUP + this.$scope.detailsPopupId, this.tasksGrid.selectedItemId, this.tasksGrid.pageItemsIds)
    }

    private onSaveAttachment(added: OpFile): ng.IPromise<OpFile> {
        const deferred: ng.IDeferred<OpFile> = this.$q.defer<OpFile>()

        this.userSession.getDataProvider().Issue.saveIssueAttachment(this.$scope.modelId, added)
            .then((data: OpFile) => {
                deferred.resolve(data)

                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentSave))
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                this.logger.log(errorMsg)
                deferred.reject()

                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentSaveError))

                console.warn(IssueDirectiveController.LOG_STRING, `Unable to save attachemnt. Error: ${errorMsg}.`)
            })

        return deferred.promise;
    }

    private onDeleteAttachments(removed: number[]): ng.IPromise<any[]> {
        const deferred: any = this.$q.defer<number[]>()

        this.userSession.getDataProvider().Issue.deleteIssueAttachment(this.$scope.modelId, removed)
            .then(() => {
                deferred.resolve(removed)
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentDelete))
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                this.logger.log(errorMsg)

                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentDeleteError))

                console.warn(IssueDirectiveController.LOG_STRING, `Unable to delete attachment. Error: ${errorMsg}.`)
            })

        return deferred.promise;
    }

    private onSaveIssueTasks(added: any[], removed: any[]): ng.IPromise<boolean> {
        const deferred: any = this.$q.defer<boolean>()

        IssueHelper
            .saveIssueTasks(this.userSession.getDataProvider(), this.moduleName, this.referenceObject, added, removed)
            .then((savedObject: OpIssue) => {
                this.onRefresh(savedObject)

                deferred.resolve(true)
            })
            .fail((error: any) => {
                this.logger.log(error)

                deferred.resolve(false)
            })

        return deferred.promise;
    }

    // Events End

    // Setup

    public getAccordions(): any[] {
        const accordions: DetailsAccordion[] = []
        let items: DetailsAccordionSection[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueParameters)) {
            items = []

            items.push({
                name: this.ISSUE_PARAMS_ACCORDION_NAME,
                showInTab: this.ISSUE_COMMON_TAB_NAME,
                showStatus: false,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Parameters),
                visible: true,

                canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_EDIT)
                    && !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueParameters),

                editMethod: () => this.onEditIssueParams(),
            })

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.IssueDetailsAccordions, 0, items))
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueAttachments)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueTasks)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueEquipment)) {
            items = []

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueAttachments)) {
                items.push({
                    name: this.ISSUE_ATTACHMENTS_ACCORDION_NAME,
                    showInTab: this.ISSUE_COMMON_TAB_NAME,
                    showStatus: true,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Attachments),
                    visible: true,

                    canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_EDIT)
                        && !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueAttachments),

                    editMethod: () => this.onEditIssueAttachments(),
                    status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AddedCount) + (this.$scope.attachments ? this.$scope.attachments.length : 0),
                })
                this.$scope.downloadButtonOptions = {
                    onClick: (e: any) => {
                        e.event.stopPropagation()
                        this.savePackedAttachment()
                    },
                    onInitialized: (e: any) => {
                        this.$scope.downloadButton = e.component
                    },
                    icon: 'fa fa-download',
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.GetPackedAttachment),
                }
            }

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueTasks)) {
                items.push({
                    name: this.ISSUE_TASKS_ACCORDION_NAME,
                    showInTab: this.ISSUE_COMMON_TAB_NAME,
                    showStatus: true,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Tasks),
                    visible: true,

                    canEdit: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_EDIT)
                        && !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_READONLY_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueTasks),

                    editMethod: () => this.onEditIssueTasks(),
                    status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AssignedCount) + (this.referenceObject.taskList ? this.referenceObject.taskList.length : 0),
                })
            }

            if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueEquipment)) {
                items.push({
                    name: this.ISSUE_EQUIPMENT_ACCORDION_NAME,
                    showInTab: this.ISSUE_COMMON_TAB_NAME,
                    showStatus: true,
                    title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Equipment),
                    visible: true,

                    canEdit: false,

                    status: () => LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Equipment) + ': ' + (this.$scope.equipments ? this.$scope.equipments.length : 0),

                })
            }

            accordions.push(new DetailsAccordion(this.$scope, this.$timeout, OperatorLayoutSettings.IssueDetailsAccordions, 1, items))
        }

        return accordions
    }

    public getTabs(): any[] {
        const tabs: any[] = []

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueTasks)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueParameters)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueAttachments)
            || !this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueEquipment)
        ) {
            tabs.push({
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Common),
                    ConfigHelper.Icon.HOME,
                    this.userSession
                ),
                name: this.ISSUE_COMMON_TAB_NAME
            })
        }

        if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueHistory)) {
            tabs.push({
                template: TemplateHelper.getContextMenuItem(
                    LocalizationHelper.getLocalizedText(LocalizationHelper.Text.History),
                    ConfigHelper.Icon.HISTORY,
                    this.userSession
                ),
                name: this.ISSUE_HISTORY_TAB_NAME
            })
        }

        return tabs
    }

    private setAttachmentOptions(): void {
        if (!this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DETAILS_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.IssueAttachments)) {

            this.$scope.attachmentsBridge = {
                id: null,
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AttachmentsEdit),
                items: [],
                columns: this.attachmentService.getAttachmentGridColumns(),
                popupId: this.$scope.detailsPopupId + 'attachments',
                allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueAttachments),
                deleteAttachmentPermission: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_ATTACHMENT_DELETE),
                onDelete: (removed: number[]) => this.onDeleteAttachments(removed),
                onFileAdded: (added: OpFile) => this.onSaveAttachment(added),
            }
        }
    }

    private setConfirmationsOptions(): void {
        this.$scope.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            (event: ng.IAngularEvent, ...args: any[]) => this.onOpen(args[3])
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName) + this.$scope.id,
            () => this.onClose()
        )

        this.$scope.$on(EventsNames.ISSUE_ATTACHMENT_COUNT_CHANGED, () => {
            this.$timeout(() => {

                this.$scope.attachmentsBridge.items = this.$scope.attachments
                this.$scope.attachmentsBridge.title = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AttachmentsEdit) + " (" + this.$scope.attachments.length + ")"

                if (this.attachmentsGrid) {
                    this.attachmentsGrid.setDataSource(this.$scope.attachments)
                    this.attachmentsGrid.dxGrid.refresh()
                }
            }, 200)
        })

        this.$scope.$on(EventsNames.DOWNLOAD_ISSUE_ATTACHMENT + this.$scope.detailsPopupId, (event: ng.IAngularEvent, ...args: any[]) => {
            FileComponent.OpenFileSaver(this.attachmentsGrid.selectedItem)
        })

        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => this.onRefresh(args[0]))
    }

    private setAttachmentsOptions(): void {
        this.$scope.downloadAttachment = () => { this.downloadAttachment() }
        this.$scope.resizePreview = () => { this.resizePreview() }
    }

    private setTaskGridOptions(result: OpTask[], columns): void {
        this.$scope.issueTasksGridOptions = null

        this.$timeout(() => {
            this.$scope.issueTasksGridOptions = {
                name: 'issueTasks',
                idReferenceType: Enums.ReferenceType.IdTask,
                type: GridTypes.NO_SEARCH_BAR_SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                onInitialized: (e: any, tasksGrid: GridController<OpTask>) => {
                    this.tasksGrid = tasksGrid
                },
                addCustomFilters: true,
                dataSource: result,
                columnsDictionary: columns,
                allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueTasks),
                onRowDoubleClick: (e: any) => this.onTaskDetailsPopupOpen(e)
            }
        }, 100)
    }

    private setTasksEditOptions(res: OpTask[], columns: ColumnModel[]): void {
        this.$scope.issueTasksEditOptions = {
            columns: columns,
            id: this.referenceObjectId,
            items: res.map((task: OpTask) => this.gridService.gridObjectFromIOpObject(task)),
            name: 'issueTasksGrid',
            popupId: this.$scope.detailsPopupId + 'tasks',
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.TasksEdit),

            allowColumnReordering: !this.userSession
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueTasks),

            getAvailableDataSourceMethod: this.userSession.getDataProvider().Task.getTaskFilter,

            onSubmit: (added, removed) => this.onSaveIssueTasks(added, removed)
        }
    }

    private resizePreview(): void {
        this.$scope.isAttachmentPreviewFullscreen = !this.$scope.isAttachmentPreviewFullscreen
        const attachmentPreviewElement: any = angular.element('.attachment-preview-container')

        if (this.$scope.isAttachmentPreviewFullscreen) {
            this.parentElement = attachmentPreviewElement.parent()
            attachmentPreviewElement.appendTo('body')
        } else {
            attachmentPreviewElement.appendTo(this.parentElement)
        }
    }

    private downloadAttachment(): void {
        FileComponent.OpenFileSaver(this.attachmentsGrid.selectedItem)
    }

    private setOptions(): void {
        this.$scope.options = <DetailsPopupOptions>{
            id: this.$scope.id,

            closeEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__CLOSE_DETAILS_POPUP, this.moduleName),
            delHasPermissions: this.userSession.getLoggedOperator().hasPermission(Activity.ISSUE_DEL) ? Activity[Activity.ISSUE_DEL] : null,
            openEventName: EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_DETAILS_POPUP, this.moduleName),
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DETAILS, this.moduleName),

            deleteMethod: () => this.onDeleteIssue(),
            getAccordionDataMethod: () => this.getAccordionData(),
            getAccordionSelectionMethod: () => this.getAccordionSelection(),
            updateAccordionMethod: (names: any[]) => this.updateAccordions(names)
        }
    }

    private setHistoryOptions(): void {
        this.$scope.issuesHistoryOptions = {
            dataMethodName: null,
            id: null,
            name: 'issuesHistory',
            referenceType: this.referenceType,
            referenceValue: this.referenceObjectId,
            allowColumnReordering: !this.userSession
                .getLoggedOperator()
                .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueHistory),
        }
    }

    private getEquipmentData(result: OpIssue): void {
        if (result.idLocation != null) {
            this.userSession
                .getDataProvider().Location
                .getLocationEquipment(result.idLocation)
                .then((result: any[]) => {
                    this.$scope.equipments = result
                    this.setEquipmentGridOptions(result)
                })
        } else {
            this.setEquipmentGridOptions(null)
        }
    }

    private setBasicParameters(result: OpIssue): void {
        DataTypeGroupComponent
            .getDataTypeInGroupByModule(
                this.userSession.getDataProvider(),
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY,
                this.moduleName
            )
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.$scope.detailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: this.referenceType,
                    referenceObject: this.referenceObject,
                    useDynamicValues: true
                }
            })
    }

    private setTaskColumns(result: OpIssue): void {
        this.userSession
            .getDataProvider().System
            .getRequestColumnInfo(Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__TASK_GRID_PARAMS, this.moduleName, { viewReferenceType: Enums.ReferenceType.IdTask })
            .then((columns: ColumnModel[]) => {
                this.setTaskGridOptions(result.taskList, columns)
                this.setTasksEditOptions(result.taskList, columns)
            })
    }

    private setEquipmentGridOptions(equipment: any[]): void {
        this.$scope.equipmentGridOptions = null

        this.$timeout(() => {
            this.$scope.equipmentGridOptions = {
                name: 'issueEquipment',
                idReferenceType: Enums.ReferenceType.IdLocation,
                type: GridTypes.NO_SEARCH_BAR_SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                addCustomFilters: true,
                dataSource: equipment,
                columnsDictionary: IssueHelper.getIssueEquipmentGridColumns(),
                allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueEquipment)
            }
        }, 100)
    }

    private getAttachmentData(): void {
        this.userSession
            .getDataProvider().Issue
            .getIssueAttachment(this.referenceObjectId)
            .then((result: OpFile[]) => {
                this.$scope.attachments = result
                this.setAttachmentsEditOptions(result)
                this.setAttachmentGridOptions(result)
            }).fail((error) => {
                console.warn(error)
            })
    }

    private setAttachmentGridOptions(attachments: OpFile[]): void {
        this.$scope.attachmentsGridOptions = null
        const attachmentsColumns: ColumnModel[] = IssueHelper.getIssueAttachmentGridColumns()
        attachmentsColumns.push(CommonHelper.getAttachmentButtonColumn(this.$scope, EventsNames.DOWNLOAD_ISSUE_ATTACHMENT + this.$scope.detailsPopupId))

        this.$timeout(() => {
            this.$scope.attachmentsGridOptions = {
                name: "attachments",
                idReferenceType: Enums.ReferenceType.IdFile,
                type: GridTypes.NO_SEARCH_BAR_SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                addCustomFilters: true,
                dataSource: attachments,
                columnsDictionary: attachmentsColumns,
                allowColumnReordering: !this.userSession.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.IssueAttachments),
                onRowDoubleClick: (e: any) => { this.onRowDoubleClick(e) },
                onInitialized: (e: any, attachmentsGrid: GridController<OpFile>) => { this.onInitialized(e, attachmentsGrid) },
                onContentReady: (e: any) => { this.onContentReady(e) },
                onSelectionChanged: (e: any) => { this.showPreview() }
            }
            if (this.$scope.downloadButton) {
                this.$scope.downloadButton.option('visible', !!attachments.length)
            }
        }, 100)
    }

    private setAttachmentsEditOptions(result: OpFile[]): void {
        this.$scope.showAttPreview = false
        this.$scope.attachmentsGridOptions = null
        this.$scope.attachment = result
        this.$scope.attachmentsBridge.items = result
        this.$scope.attachmentsBridge.title = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AttachmentsEdit) + " (" + this.$scope.attachments.length + ")"

        this.$scope.isAttachLoading = false
    }

    private onRowDoubleClick(e): void {
        FileComponent.OpenFileSaver(this.attachmentsGrid.selectedItem)
    }

    private onInitialized(e, attachmentsGrid): void {
        this.attachmentsGrid = attachmentsGrid
    }

   private onContentReady(e: any): void {
        this.showPreview()
    }

    private showPreview(): void {
        if (this.attachmentsGrid.selectedItem) {
            this.image.setImage(this.attachmentsGrid.selectedItem)
        }
    }

    private setTemplateConsts(): void {
        this.$scope.ISSUE_COMMON_TAB_NAME = this.ISSUE_COMMON_TAB_NAME
        this.$scope.ISSUE_HISTORY_TAB_NAME = this.ISSUE_HISTORY_TAB_NAME
        this.$scope.ISSUE_ATTACHMENTS_ACCORDION_NAME = this.ISSUE_ATTACHMENTS_ACCORDION_NAME
        this.$scope.ISSUE_PARAMS_ACCORDION_NAME = this.ISSUE_PARAMS_ACCORDION_NAME
        this.$scope.ISSUE_TASKS_ACCORDION_NAME = this.ISSUE_TASKS_ACCORDION_NAME
        this.$scope.ISSUE_EQUIPMENT_ACCORDION_NAME = this.ISSUE_EQUIPMENT_ACCORDION_NAME
    }


    private savePackedAttachment(): void {
        this.userSession.getDataProvider()
            .Issue.getIssueAttachmentPacked(this.referenceObjectId, null)
            .then((result: OpFile) => {
                FileComponent.OpenFileSaver(result)
            }).fail((error: any) => {
                ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AttachmentDownloadError))
            })
    }

 // #region IMRImage

    private setImageOptions(): void {
        this.imageOptions = {
            onInitialized: (e: IMRImageInitializedArgs) => {
                this.image = e.component
            },
        }
    }

    // #endregion

    // Setup End

    resetData() { this.onClear() }//DO USUNIECIA!!! - zastąpić onClear
    loadData(id: number, objects: any[]) { this.onOpen(null) }//DO USUNIECIA!!! - zastąpić onOpen
    updateData(result: any) { this.onRefresh(result) }//DO USUNIECIA!!! - zastąpić onRefresh
}